
//CODIGOS
export const DNI = '1';
export const CARNET = '4';
export const RUC = '6';
export const PASAPORTE = '7';
export const CEDULA = 'A';
export const OTRO = '0';

//LONGITUDES
export const DNI_LONGITUD = 8;
export const CARNET_LONGITUD = 12;
export const RUC_LONGITUD = 11;
export const PASAPORTE_LONGITUD = 12;
export const CEDULA_LONGITUD = 12;
export const OTRO_LONGITUD = 15;

//EXACTO
export const DNI_EXACTO = true;
export const CARNET_EXACTO = false;
export const RUC_EXACTO = true;
export const PASAPORTE_EXACTO = false;
export const CEDULA_EXACTO = false;
export const OTRO_EXACTO = false;

//NOMBRES
export const DNI_NOMBRE = 'DNI';
export const CARNET_NOMBRE = 'Carnet de extranjería';
export const RUC_NOMBRE = 'RUC';
export const PASAPORTE_NOMBRE = 'Pasaporte';
export const CEDULA_NOMBRE = 'Cédula diplomática de indentidad';
export const OTRO_NOMBRE = 'Otro';